export const C_ARRANGEMENTS_TYPE = {
  EXCLUSIVE: {
    name: "Exclusivo",
    id: 1,
    value: "Exclusive",
    label: "Exclusivo"
  },
  PARTIALLY_EXCLUSIVE: {
    name: "Parcialmente Exclusivo",
    id: 2,
    value: "Partially Exclusive",
    label: "Parcialmente Exclusivo"
  },
  NO_EXCLUSIVE: {
    name: "No Exclusivo",
    id: 3,
    value: "No Exclusive",
    label: "No Exclusivo"
  }
};

export const O_ARRANGEMENTS_TYPE = {
  [C_ARRANGEMENTS_TYPE.EXCLUSIVE.name]: C_ARRANGEMENTS_TYPE.EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE.name]:
    C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE.name]:
    C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.EXCLUSIVE.id]: C_ARRANGEMENTS_TYPE.EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE.id]:
    C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE.id]: C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.EXCLUSIVE.value]: C_ARRANGEMENTS_TYPE.EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE.value]:
    C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE,
  [C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE.value]:
    C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE
};

export const A_ARRANGEMENTS_TYPE = [
  C_ARRANGEMENTS_TYPE.EXCLUSIVE,
  C_ARRANGEMENTS_TYPE.PARTIALLY_EXCLUSIVE,
  C_ARRANGEMENTS_TYPE.NO_EXCLUSIVE
];

/**
 *  Exclusivo 1
 *  parcialmente exclusivo 2
 * no exclusivo 3
 *
 *
 */
